import request from '@/utils/request'

export function list(data) {
    return request({
        module: 'center',
        url: '/area/list',
        method: 'post',
        data: data
    })
}

export function getArea(level, fatherCode) {
    return request({
        module: 'center',
        url: '/area/' + level + '/' + fatherCode,
        method: 'get'
    })
}

export function getAreaList(code) {
    return request({
        module: 'center',
        url: '/area/areaList/' + code,
        method: 'get'
    })
}

export function getAreaTreeByLevel(data) {
    return request({
        module: 'center',
        url: '/area/getAreaTreeByLevel',
        method: 'post',
        data: data,
        type: 'app'
    })
}

export function getProvinces() {
    return request({
        module: 'center',
        url: '/area/getProvinces',
        method: 'get'
    })
}



// WEBPACK FOOTER //
// ./src/api/center/area.js